import React, { FC } from 'react';

import styled from 'styled-components';

import { useLocale } from '@adsk/alloy-react-locale';
import Theme from '@adsk/alloy-react-theme';

const Container = styled.span({ color: Theme.colors.charcoal500 });

const LoadingErrorCell: FC = () => {
  const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));
  return <Container>{T.translate('LOADING_ERROR')}</Container>;
};

export default LoadingErrorCell;
